// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill';
import promise from 'es6-promise';

promise.polyfill();

// import 'swiper/dist/js/swiper.min';

// import Swiper from 'swiper';
// import 'swiper/swiper.min.css';

// import 'swiper/dist/css/swiper.css';

import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/golabl.css';
import '@/utils/size.js';

import $ from 'jquery';
Vue.prototype.$ = $;
// import 'bootstrap/dist/js/bootstrap.min';
// import 'bootstrap/dist/css/bootstrap.min.css';

// import 'lib-flexible';

// 全局引入VideoPlayer
// import VideoPlayer from 'vue-video-player';
// import 'vue-video-player/src/custom-theme.css';
// import 'video.js/dist/video-js.css';
// 使用VideoPlayer
// Vue.use(VideoPlayer);
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import VueDPlayer from 'vue-dplayer';
import 'vue-dplayer/dist/vue-dplayer.css';
Vue.use(VueDPlayer);


Vue.config.productionTip = false;
Vue.use(ElementUI);
//全局引入图片预览插件
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);
Viewer.setDefaults({
    Options: {
        inline: true, //启用lnline模式
        button: true, //显示右上角关闭按钮
        navbar: true, //显示缩略图导航
        title: true, //显示当前图片的标题
        toolbar: true, //显示工具栏
        tooltip: true, //显示缩放百分比
        movable: true, //显示可移动
        zoomable: true, //图片是否可缩放
        rotatable: true, //图片是否可旋转
        scalable: true, //图片是否可翻转
        transition: true, //使用css3过度
        fullscreen: true, //播放时是否全屏
        keyboard: true, //是否支持键盘
        url: 'data-source', //设置大图片的url
    },
});
import router from './router';

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    beforeCreate() {
        Vue.prototype.$bus = this; //安装全局事件总线
    },
});

router.beforeEach;
// 如果是移动端，则路由变化的时候返回页面顶部

// 路由变化返回页面顶部
router.afterEach((to, from, next) => {
    // console.log('路由变化了');
    // console.log('to==', to);
    // let heightBanner = document.getElementById('caroul').offsetHeight;
    // let topH = document.getElementById('boxFixed').offsetHeight;
    // let height = heightBanner - topH;
    // setTimeout(() => {
    //     window.scrollTo(0, height);
    // }, 300);
    // console.log(from);
    // console.log(next);
    // window.scrollTo(0, 0);
    // let height = window.innerHeight
    // window.scrollTo(0, height);
    // console.log('aaaaa');
});



// WEBPACK FOOTER //
// ./src/main.js